import { IOrganization } from "./Organization";
import { ICreateEntity, ISharedEntityFields } from "./shared/SharedEntityFields";

export interface IOrganizationIntegration extends ISharedEntityFields {
  integrationId: `${OrganizationIntegrationId}` | OrganizationIntegrationId;
  apiKey: string;
  secretApiKey?: string; // some integrations (e.g. Klaviyo) may have a "private" API
  organizationIntegrationProperties?: OrganizationIntegrationProperties;
  organization: IOrganization;
}

export enum PostscriptIntegrationEvents {
  SUBSCRIPTION_FAILED_PAYMENT = "SMARTRR_SUBSCRIPTION_FAILED_PAYMENT",
  SUBSCRIPTION_UPCOMING_ORDER = "SMARTRR_SUBSCRIPTION_UPCOMING_ORDER",
  SUBSCRIPTION_CREATED = "SMARTRR_SUBSCRIPTION_CREATED",
  SUBSCRIPTION_ORDER_SKIPPED = "SMARTRR_SUBSCRIPTION_ORDER_SKIPPED",
  SUBSCRIPTION_CANCELLED = "SMARTRR_SUBSCRIPTION_CANCELLED",
  PAYMENT_METHOD_UPDATED = "SMARTRR_PAYMENT_METHOD_UPDATED",
  CUSTOMER_DEACTIVATED = "SMARTRR_CUSTOMER_DEACTIVATED",
}

export interface PostscriptIntegrationProperties {
  shopPostscriptId: string;
  postscriptWebhookOptInSubscriptionId: string;
  postscriptWebhookOptOutSubscriptionId: string;
  postscriptWebhookMessageReceivedSubscriptionId?: string;
  upcomingOrderTriggerId?: string;
  subscriptionCreatedTriggerId?: string;
  failedPaymentTriggerId?: string;
  paymentUpdateTriggerId?: string;
  skippedOrderTriggerId?: string;
  customerDeactivatedTriggerId?: string;
  upcomingOrderEventId?: string;
  subscriptionCreatedEventId?: string;
  failedPaymentEventId?: string;
  paymentUpdateEventId?: string;
  skippedOrderEventId?: string;
  subscriptionCancelledEventId?: string;
  customerDeactivatedEventId?: string;
}

export interface GorgiasIntegrationProperties {
  nonce: string;
  widgetId: string;
  integrationId: string;
  refreshToken: string;
  domain: string;
}
export interface KlaviyoIntegrationProperties {
  v2EventsOnly: boolean;
  useOAuth?: boolean;
  codeVerifier?: string;
  accessToken?: string;
  refreshToken?: string;
}

export enum SavedByInstallationStatus {
  INSTALLED = "INSTALLED",
  NOT_INSTALLED = "NOT_INSTALLED",
}

export interface SavedByIntegrationProperties {
  installationStatus: SavedByInstallationStatus;
  productId: string;
  feeTiers: {
    min: string;
    max: string;
    variantId: string;
  }[];
}

export interface SavedByIntegrationStatusData {
  status: SavedByInstallationStatus;
  productId: string;
}

export interface OrganizationIntegrationProperties {
  postscript?: PostscriptIntegrationProperties;
  klaviyo?: KlaviyoIntegrationProperties;
  gorgias?: GorgiasIntegrationProperties;
  savedBy?: SavedByIntegrationProperties;
}

export type IOrganizationIntegrationCreate = ICreateEntity<IOrganizationIntegration>;

export enum OrganizationIntegrationId {
  KLAVIYO = "klaviyo",
  LOYALTY_LION = "loyalty_lion",
  RECHARGE = "recharge",
  POSTSCRIPT = "postscript",
  ATTENTIVE = "attentive",
  SHOPIFY_FLOW = "shopify_flow",
  ARPU = "arpu",
  GORGIAS = "gorgias",
  SAVEDBY = "savedBy",
}

export interface OrganizationIntegrationKeyProperties {
  apiKey: string;
  secretApiKey?: string;
}
